module.exports = __webpack_public_path__ + "static/images/equalizer.e066aa2.jpg";